const NewsRouter = [
  {
    path: '/news/category',
    name: 'ManageNewsCategory',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/News/Category/index.vue'),
    meta: {
      title: 'Quản lý danh mục tin tức',
      openSidebarKey: 'news',
    }
  },
  {
    path: '/news/category/create',
    name: 'CreateNewsCategory',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/News/Category/Controller.vue'),
    meta: {
      title: 'Tạo danh mục tin tức',
      openSidebarKey: 'news',
    }
  },
  {
    path: '/news/category/:id',
    name: 'UpdateNewsCategory',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/News/Category/Controller.vue'),
    meta: {
      title: 'Cập nhật danh mục tin tức',
      openSidebarKey: 'news',
    }
  },

  {
    path: '/news/article',
    name: 'ManageArticle',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/News/Article/index.vue'),
    meta: {
      title: 'Danh sách bài viết',
      openSidebarKey: 'news',
    }
  },
  {
    path: '/news/article/create',
    name: 'CreateArticle',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/News/Article/Controller.vue'),
    meta: {
      title: 'Tạo bài viết',
      openSidebarKey: 'news',
    }
  },
  {
    path: '/news/article/update/:id',
    name: 'UpdateArticle',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/News/Article/Controller.vue'),
    meta: {
      title: 'Cập nhật bài viết',
      openSidebarKey: 'news',
    }
  }
]

export default NewsRouter